<app-userapi-shared-non-oauth [userApi]="userApi">

  <p [innerHTML]="userApi.api.configDescription"></p>

  <FloatingLabelInput
      id="publicKey"
      class="form-label"
      [label]="userApi.api.placeholder1 | translate"
      [appColor]="appColor()"
      [(myValue)]="userApi.publicKey"
      (myValueChange)="userApi.configured = !!userApi.publicKey && !!userApi.privateKey && !!userApi.customConfig1">
  </FloatingLabelInput>

  <FloatingLabelInput
      id="privateKey"
      class="form-label"
      [label]="userApi.api.placeholder2 | translate"
      [appColor]="appColor()"
      [(myValue)]="userApi.privateKey"
      (myValueChange)="userApi.configured = !!userApi.publicKey && !!userApi.privateKey && !!userApi.customConfig1">
  </FloatingLabelInput>

  <FloatingLabelInput
      id="customConfig1"
      class="form-label"
      [label]="userApi.api.placeholder3 | translate"
      [appColor]="appColor()"
      [(myValue)]="userApi.customConfig1"
      (myValueChange)="userApi.configured = !!userApi.publicKey && !!userApi.privateKey && !!userApi.customConfig1">
  </FloatingLabelInput>

</app-userapi-shared-non-oauth>